module.exports = __webpack_public_path__ + "static/img/aqjg.ca4ce93.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/aqjg.jpg
// module id = VgMt
// module chunks = 0